import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Cookie } from 'ng2-cookies';
import { Constant } from '../../../shared/constants/constant.class';

@Component({
  selector: 'app-license-expired',
  templateUrl: './license-expired.component.html',
  styleUrls: ['./license-expired.component.scss']
})
export class LicenseExpiredComponent implements OnInit {
  // Thông tin lỗi license do error.interceptor.ts lưu tạm vào localStorage trước khi
  // điều hướng sang trang này (vì redirect không tiện truyền state phức tạp, và
  // localStorage cũng sống sót qua F5).
  title = 'Hết hạn sử dụng';
  detailMessage = '';
  generalMessage = '';
  dateExpired: Date | null = null;
  remainDay: number | null = null;

  constructor(private router: Router) { }

  ngOnInit(): void {
    try {
      const raw = localStorage.getItem(Constant.LICENSE_INFO);
      if (raw) {
        const info = JSON.parse(raw);
        this.detailMessage = info.detail || '';
        this.generalMessage = info.message || '';
        this.remainDay = (info.remainDay !== undefined && info.remainDay !== null) ? info.remainDay : null;
        // BE trả "0001-01-01T00:00:00" khi chưa có/không hợp lệ -> bỏ qua, không hiển thị
        if (info.dateExpired && !(`${info.dateExpired}`.startsWith('0001-01-01'))) {
          this.dateExpired = new Date(info.dateExpired);
        }
      }
    } catch (e) {
      // ignore, hiển thị message mặc định
    }
  }

  backToLogin(): void {
    // Dọn sạch token cũ (nếu còn sót) để chắc chắn không bị bounce ngược lại dashboard
    localStorage.removeItem(Constant.TOKEN);
    localStorage.removeItem(Constant.USER_INFO);
    localStorage.removeItem(Constant.LICENSE_INFO);
    Cookie.delete(Constant.TOKEN);
    this.router.navigate([Constant.LOGIN]);
  }
}
